const encodeBase64url = (bytes: Uint8Array): string => {
    return btoa(String.fromCodePoint(...bytes))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
};

const generateRandomBase64url = (byteLength: number): string => {
    return encodeBase64url(crypto.getRandomValues(new Uint8Array(byteLength)));
};

/** 32 bytes encode to 43 characters, the minimum length RFC 7636 allows. */
export const createCodeVerifier = (): string => generateRandomBase64url(32);

export const createState = (): string => generateRandomBase64url(16);

export const createCodeChallenge = async (codeVerifier: string): Promise<string> => {
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier));
    return encodeBase64url(new Uint8Array(digest));
};
